import { StatefulParticipant } from 'components/calls/lib/sendbird-calls';
import { ParticipantId, ParticipantNickname, ParticipantWrapper } from './styles';

export const Participant = ({ participant }: { participant: StatefulParticipant }) => {
  return (
    <ParticipantWrapper src={participant.user.profileUrl || '/icons/icon-avatar.svg'}>
      <div />
      <div>
        <ParticipantNickname>{participant.user.nickname || '—'}</ParticipantNickname>
        <ParticipantId>User ID: {participant.user.userId}</ParticipantId>
      </div>
    </ParticipantWrapper>
  );
};
